'use client';

import { useEffect } from 'react';

import { useRouter } from 'next/navigation';

interface Props {
  name: string;
  value: string;
  refresh?: boolean;
}

export default function SetCookie({ name, value, refresh }: Props) {
  const router = useRouter();

  useEffect(() => {
    try {
      document.cookie = `${name}=${value}; path=/`;

      if (refresh) {
        router.refresh();
      }
    } catch {}
  }, [name, value, refresh, router]);

  return null;
}
